<template>
  <div>
    <div>
      <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
        You are applying to a default classification. Select any additional
        {{ brokerName }} classifications that may apply to you.
      </h4>
      <div>
        <p class="categoryParagraph">Classifications (Optional)</p>
        <div class="flex flex-wrap items-start">
          <div
            v-for="item in carrierElectedOptions"
            :key="item"
            class="w-1/2 p-1 md:w-1/2"
          >
            <radio-button
              :key="`carrier_elected_classification_${item?.id}`"
              :item="item?.name"
              :active="
                currentCarrierElectedClassificationIds?.includes(item?.id)
                  ? true
                  : false
              "
              :handle-select="handleSelectConnectionClassification"
              :name="`carrier_elected_classification_${item?.id}`"
            />
          </div>
        </div>
      </div>
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      :hide-back-button="true"
      @next="handleNext"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed } from 'vue';
import RadioButton from '@/components/RadioButton.vue';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'Classifications',
  components: {
    FormNavigationButtons,
    RadioButton,
  },
  props: {
    data: Object,
    updateField: Function,
    nextStep: Function,
    formPosition: Number,
    title: String,
    firstTime: Boolean,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  setup(_, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Classifications';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    // const firstTime = computed(() => store.state.firstTime?.[formRouter.componentStep.value?.firstTimeIdentifier]);
    const buttonsToDisplay = 'continue-save';
    const isButtonDisabled = false;
    // const initialRoute = computed(() => formRouter.initialRoute.value);
    const classificationsNextIdentifier = computed(
      () => store.state.formRoutes?.classificationsNextIdentifier
    );

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR | ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      if (classificationsNextIdentifier.value) {
        formRouter.moveToStepByIdentifier(classificationsNextIdentifier.value);
      } else {
        formRouter.moveToCurrentStageStep();
      }
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      emitExitModal,
    };
  },
  computed: {
    availableCarrierElectedClassifications() {
      return (
        this.$store.state.carriers.availableCarrierElectedClassifications || []
      );
    },
    brokerName() {
      return this.$store.state.brokers?.logo?.legal_name;
    },
    currentCarrierElectedClassifications() {
      return this.$store.state.carriers.carrierElectedClassifications || [];
    },
    currentCarrierElectedClassificationIds() {
      let classifications =
        this.$store.state.carriers.carrierElectedClassifications || [];
      return classifications.map(function (c) {
        return c.classification_id;
      });
    },
    carrierElectedOptions() {
      if (this.availableCarrierElectedClassifications?.length > 0) {
        let options = [...this.availableCarrierElectedClassifications];
        return options;
      } else {
        return false;
      }
    },
  },
  async beforeMount() {
    await this.$store.dispatch(
      'carriers/getAvailableCarrierElectedClassifications'
    );
    await this.$store.dispatch(
      'carriers/getCurrentCarrierElectedClassifications'
    );
  },
  async mounted() {
    await this.$store.dispatch(
      'carriers/completeCarrierElectedClassificationsStage'
    );
  },
  methods: {
    handleSelectConnectionClassification: async function (e) {
      console.log('running handleSelectConnectionClassification');
      let id = e?.target?.name?.replace('carrier_elected_classification_', '');
      let removeElectionId = null;
      if (this.currentCarrierElectedClassificationIds?.length > 0) {
        this.currentCarrierElectedClassifications.forEach(function (el) {
          if (el?.classification_id == id) {
            removeElectionId = el?.id;
          }
        });
      }
      if (id > 0) {
        let res = await this.$store.dispatch(
          'carriers/createOrDeleteConnectionClassification',
          {
            elected_classification_id: id,
            remove_election_id: removeElectionId,
          }
        );
        console.log('res:');
        console.dir(res);
        if ([200, 201].includes(res?.status) && removeElectionId == null) {
          toastResponse(this, res, 'Classification added');
        } else if ([204].includes(res?.status)) {
          toastResponse(this, res, 'Classification removed');
        }
      }
    },
  },
};
</script>
<style scoped>
p {
  @apply text-left;
}
.categoryParagraph {
  @apply mb-1 text-xxs font-bold uppercase text-gray-over-dark;
}
</style>
